import { ChangeDetectorRef, Component, DoCheck, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core"
import { MatDialog } from "@angular/material"
import { MapMarker } from "src/app/models/marker"
import { MapService } from "src/app/services/map.service"
import { ITALY_CENTER } from "src/configs/map_configuration"
import { environment } from "src/environments/environment"
import mapStyle from "./google-map-theme-silver.json"
import { ModalLegendaComponent } from "../../modals/modal-legenda/modal-legenda.component"

@Component({
	selector: "app-gmap",
	templateUrl: "./gmap.component.html",
	styleUrls: ["./gmap.component.scss"]
})
export class GMapComponent implements OnInit {
  @ViewChild('gmap', { static: true }) gmapElement: any;
  @Output() mapReady = new EventEmitter<google.maps.Map>();
  @Output() markerClicked = new EventEmitter<any>();
  @Output() pickedClicked = new EventEmitter<any>();
  @Output() idle = new EventEmitter<any>();
  @Output() boundsChanged = new EventEmitter<any>();
  @Output() clickedButton = new EventEmitter<any>();
  @Output() clickLegenda = new EventEmitter<any>();
  map: google.maps.Map;
  public picked: MapMarker;
  public markersShown = [];
  public linesShown: google.maps.Polyline[] = [];
  public kmlShown = [];
  public setTimeoutClick: any;
  public emitFirstMap = false;
  public notEmitBounds = false;
  public assets_version = environment.ASSETS_VERSION;
  private mapLoaded = false;
  private timeoutZoom: any;
  private timeoutIdle: any;


	public changeDetectorTrigger: any = {
		changer: 1
	}


  constructor(public mapService: MapService, public dialog: MatDialog) { }

	ngOnInit() {
		const mapProp = {
			center: ITALY_CENTER,
			zoom: 6,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			mapTypeControl: false,
			streetViewControl: false,
			disableDoubleClickZoom: false,
			scrollwheel: true,
			zoomControlOptions: { position: google.maps.ControlPosition.TOP_RIGHT }
		}
		this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp)

		const mapstyle = mapStyle as any
		const styledMapType = new google.maps.StyledMapType(mapstyle, {
			name: "Styled Map"
		})
		this.map.mapTypes.set("styled_map", styledMapType)
		this.map.setMapTypeId("styled_map")

    // Listeners
    google.maps.event.addListener(this.map, 'bounds_changed', (event) => {
      if (!this.notEmitBounds) {
        const bounds = this.map.getBounds();
        this.boundsChanged.emit(bounds);
      }
    });
    google.maps.event.addListener(this.map, 'dblclick', () => {
      clearTimeout(this.setTimeoutClick);
    });
    google.maps.event.addListener(this.map, 'click', (event) => {
      this.setTimeoutClick = setTimeout(() => {
        this.pickedClicked.emit(event);
      }, 300);
    });
    google.maps.event.addListener(this.map, 'idle', () => {
      if (!this.mapLoaded) {
        this.mapReady.emit(this.map);
        this.mapLoaded = true;
      } else {
        if (this.timeoutIdle) {
          clearTimeout(this.timeoutIdle)
        }
        this.timeoutIdle = setTimeout(()=> {
          const zoom = this.map.getZoom();
          this.idle.emit(zoom);
        },500)
      }
    });
  }

	public onClickMapButton(type) {
		this.clickedButton.emit(type)
	}

	// Markers
	private drawMarkers(markers) {
		if (!markers) {
			return
		}
		markers.forEach(m => {
			const infowindow = new google.maps.InfoWindow({})
			let iconMarker: any
			if (m.icons) {
				const zoomMap = this.map.getZoom()
				const found = m.icons.findIndex(
					i =>
						zoomMap >= i.zoom_from &&
						zoomMap <= i.zoom_to &&
						(i.area_type ? i.area_type === m.area_type : true)
				)
				if (found >= 0) {
					iconMarker = m.icons[found].path
				}
			}
			const marker = new google.maps.Marker({
				position: m.coordinates,
				icon: iconMarker,
				label: m.label_inside ? m.label : null,
				clickable: m.can_click
			})
			marker.setZIndex(m.type === "POINT_PICKED_B" || m.type === "POINT_PICKED_A" ? 9999 : 1)
			marker["type"] = m.type
			marker["range"] = m.range
			if (m.can_hover) {
				marker.addListener("mouseover", () => {
					infowindow.setContent(m.label)
					infowindow.open(this.map, marker)
				})
				marker.addListener("mouseout", () => {
					infowindow.close()
				})
			}
			if (m.can_click) {
				marker.addListener("click", () => {
					this.markerClicked.emit(m)
				})
			}
			// marker.setMap(this.map);
			const zoom = this.map.getZoom()
			if (m.range.min !== null && zoom >= m.range.min && (m.range.max == null || zoom < m.range.max)) {
				marker.setMap(this.map)
			} else if (m.range.min == null || zoom < m.range.min || zoom > m.range.max) {
				marker.setMap(null)
			}
			this.markersShown.push(marker)
		})
		// this.cdr.detectChanges();
	}

	public showMarkers(markers, opts?) {
		if (opts && opts.clearTypes) {
			this.removeMarkersByTypes(opts.clearTypes)
		}
		this.drawMarkers(markers)
	}

	public removeMarkersByTypes(types: String[]) {
		for (const type of types) {
			this.removeMarkersByType(type)
		}
	}

	public removeMarkersByType(type: String) {
		const list = this.markersShown.filter(e => e.type === type)
		for (const m of list) {
			m.setMap(null)
		}
		this.markersShown = this.markersShown.filter(e => e.type !== type)
	}

	public removeMarkersByAreaType(areaType) {
		const list = this.markersShown.filter(e => e.area_type === areaType)
		for (const m of list) {
			m.setMap(null)
		}
		this.markersShown = this.markersShown.filter(e => e.area_type !== areaType)
	}

	private drawLines(lines, type) {
		for (const line of lines) {
			line["type"] = type
			line.setMap(this.map)
			this.linesShown.push(line)
		}
	}

	public showLines(lines: google.maps.Polyline[], type, opts?) {
		if (opts && opts.clearTypes) {
			for (const clearType of opts.clearTypes) {
				this.removeLines(clearType)
			}
		}
		this.drawLines(lines, type)
	}

	public removeLines(type) {
		const lines: google.maps.Polyline[] = this.linesShown.filter(e => e["type"] === type)
		for (const line of lines) {
			line.setMap(null)
		}
		this.linesShown = this.linesShown.filter(e => e["type"] === type)
	}

	// KML
	private drawKmlLayers(layers) {
		layers.files.forEach(url => {
			const l = new google.maps.KmlLayer({
				url: url,
				clickable: false,
				suppressInfoWindows: true,
				preserveViewport: true,
				map: this.map
			})
			this.kmlShown.push(l)
		})
	}

	public drawIndustrialLayers(url) {
		const l = new google.maps.KmlLayer({
			url: url,
			clickable: false,
			suppressInfoWindows: true,
			preserveViewport: true,
			map: this.map,
			zIndex: 50
		})
	}

	public showKmlLayers(layers) {
		this.removeKmlLayers()
		this.drawKmlLayers(layers)
	}

	public removeKmlLayers() {
		for (const layer of this.kmlShown) {
			layer.setMap(null)
		}
		this.kmlShown = []
	}

	public zoomToCoordinates(latlng, zoom = null, notEmitBounds = true) {
		zoom = zoom ? zoom : 18
		zoom = zoom >= 18 ? 18 : zoom
		this.map.setZoom(zoom)
		this.map.setCenter(latlng)
		this.notEmitBounds = notEmitBounds
		// setTimeout(() => this.notEmitBounds = false, 500);
	}

	public centerMapToCoordinates(latlng, notEmitBounds = true) {
		this.map.setCenter(latlng)
		this.notEmitBounds = notEmitBounds
		// setTimeout(() => this.notEmitBounds = false, 500);
	}

	public openLegenda() {
		this.dialog.open(ModalLegendaComponent, {
			height: "90%"
		})
	}

	public fitMapFromMarkers(markers) {
		const bounds = new google.maps.LatLngBounds()
		for (const marker of markers) {
			if (marker.coordinates && marker.coordinates.lat && marker.coordinates.lng) {
				const latlng = new google.maps.LatLng(marker.coordinates.lat, marker.coordinates.lng)
				bounds.extend(latlng)
			}
		}
		this.map.fitBounds(bounds)
	}

	public onClickMapButtonProspect() {
		if (!this.mapService.mapButtons.prospect.active) {
			this.mapService.open("warningProspectModal")
		} else {
			this.onClickMapButton("prospect")
		}
	}
}
